import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'catalogos/tipos-de-contribuciones';

/**
 * GET Tipos de Contribución (solo lectura; se administran desde el admin)
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTiposDeContribuciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
